import React from "react";

/**
 * Basit, dark/light uyumlu toggle.
 *
 * Props:
 * - checked: boolean
 * - onChange: (next:boolean) => void
 * - disabled?: boolean
 * - label?: string (opsiyonel, erişilebilirlik için aria-label)
 */
export default function ToggleSwitch({ checked, onChange, disabled = false, label }) {
  const on = !!checked;

  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={label || "toggle"}
      disabled={disabled}
      onClick={() => (!disabled ? onChange?.(!on) : null)}
      className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors border 
        ${disabled ? "opacity-60 cursor-not-allowed" : "cursor-pointer"}
        ${on ? "bg-emerald-600 border-emerald-700" : "bg-gray-200 dark:bg-gray-700 border-gray-300 dark:border-gray-600"}`}
    >
      <span
        className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform
          ${on ? "translate-x-5" : "translate-x-0"}`}
      />
    </button>
  );
}
